import React, {Component} from 'react';
import validator from "validator";
import classnames from "classnames";
import PropTypes from "prop-types";
import {getInvitedUser, register, resetPassword} from "../../store/actions/auth";
import {connect} from "react-redux";
import {addClassToBody} from "../../utils/utils";

class AcceptInvitation extends Component {
  constructor(props) {
    super(props);
    addClassToBody('auth-page');
    this.state = {
      inviting: !props.match.params.hasOwnProperty('resetKey'),
      invitedUser: {},
      inviteToken: props.match.params.token,
      password: {
        value: '',
        isValid: false,
        touched: false,
        errorMessage: ''
      },
      confirmPassword: {
        value: '',
        isValid: false,
        touched: false,
        errorMessage: ''
      },
      key: props.match.params.hasOwnProperty('resetKey') ? props.match.params.resetKey : props.match.params.token,
      formValid: false
    };
    this.handleUserInput = this.handleUserInput.bind(this);
    this.handleInputBlur = this.handleInputBlur.bind(this);
  }

  componentWillMount() {
    const token = localStorage.getItem('token');
    if (token) {
      this.props.history.push('/dashboard');
    }
  }

  componentDidMount() {
    if (this.state.inviting) {
      this.props.getInvitedUser(this.state.inviteToken);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.invitedUser) {
      this.setState({
        invitedUser: nextProps.invitedUser
      });
    }
  }

  handleUserInput(ev) {
    const fieldName = ev.target.name;
    const value = ev.target.value;

    this.setState({
      [fieldName]: {
        ...this.state[fieldName],
        value
      }
    }, () => this.validateField(fieldName, value));
  }

  handleInputBlur(ev) {
    const name = ev.target.name;

    this.setState({
      [name]: {
        ...this.state[name],
        touched: !!ev.target.value
      }
    });
  }

  validateField(fieldName, value) {
    const passwordPattern = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;
    let isValid = this.state[fieldName].isValid;
    let errorMessage = this.state[fieldName].errorMessage;

    switch (fieldName) {
      case 'password':
        isValid = value.match(passwordPattern);
        errorMessage = 'Password must be at least 8 characters long containing at least one number and a letter.';
        break;
      case 'confirmPassword':
        isValid = validator.equals(this.state.password.value, value);
        errorMessage = 'Passwords do not match.';
        break;
      default:
        break;
    }

    this.setState({
      [fieldName]: {
        ...this.state[fieldName],
        isValid,
        errorMessage
      }
    }, this.validateForm);
  }

  validateForm() {
    const {password, confirmPassword} = this.state;

    this.setState({
      formValid: password.isValid && confirmPassword.isValid
    });
  }

  onSubmit(ev) {
    ev.preventDefault();

    if (this.state.formValid) {
      const {password, confirmPassword, invitedUser} = this.state;
      const requestBody = {
        password: password.value,
        repeat_password: confirmPassword.value
      };

      if (this.state.inviting) {
        const passwordData = {
          email: this.state.invitedUser.email,
          password: password.value,
          repeat_password: confirmPassword.value
        };

        this.props.register(passwordData, invitedUser, this.props.history);
      } else {
        this.props.resetPassword(this.state.key, requestBody, this.props.history);
      }
    }
  }

  render() {
    const {password, confirmPassword, formValid, invitedUser} = this.state;
    const heading = this.state.inviting ? 'Please create a password in order to login to the system.' : 'Please set a new password in order to login to the system.';
    return (
        <section className="auth">
          <div className="container">
            <div className="row justify-content-center">
              <form className="col-md-6 col-11 auth-form" onSubmit={this.onSubmit.bind(this)}>
                <div className="form-title">
                  <h1>{heading}</h1>
                </div>
                {this.state.inviting ? (
                    <div className="form-group">
                      <label>Username / email</label>
                      <p className="form-value">{invitedUser.email}</p>
                    </div>
                ) : null}
                <div
                    className={classnames('form-group mb-4', {'invalid': !password.isValid && password.touched})}>
                  <input type="password" className="form-control" placeholder="Password" name="password"
                         value={password.value} onChange={this.handleUserInput}
                         onBlur={this.handleInputBlur}/>
                  {!password.isValid && password.touched && (
                      <p className="error-msg">{password.errorMessage}</p>)}
                </div>
                <div
                    className={classnames('form-group mb-4', {'invalid': !confirmPassword.isValid && confirmPassword.touched})}>
                  <input type="password" className="form-control" placeholder="Confirm password"
                         name="confirmPassword" value={confirmPassword.value}
                         onChange={this.handleUserInput} onBlur={this.handleInputBlur}/>
                  {!confirmPassword.isValid && confirmPassword.touched && (
                      <p className="error-msg">{confirmPassword.errorMessage}</p>)}
                </div>
                <div className="form-group text-center mb-4">
                  <button type="submit" disabled={!formValid} className="btn btn-lg btn-primary">Login
                  </button>
                </div>
              </form>
            </div>
          </div>
        </section>
    );
  }
}

AcceptInvitation.propTypes = {
  resetPassword: PropTypes.func.isRequired,
  invitedUser: PropTypes.object,
  getInvitedUser: PropTypes.func.isRequired,
  register: PropTypes.func.isRequired
};

const mapDispatchToProps = dispatch => ({
  resetPassword: (token, data, history) => dispatch(resetPassword(token, data, history)),
  getInvitedUser: token => dispatch(getInvitedUser(token)),
  register: (passwordData, userData, history) => dispatch(register(passwordData, userData, history))
});

const mapStateToProps = state => ({
  invitedUser: state.auth.invitedUser
});

export default connect(mapStateToProps, mapDispatchToProps)(AcceptInvitation);



// WEBPACK FOOTER //
// ./src/containers/AcceptInvitation/AcceptInvitation.jsx